<template>
  <input
    :id="field.identifier"
    v-model="innerValue"
    :name="field.name || field.identifier"
    type="hidden"
    v-on="$listeners"
  >
</template>
<script>
import Vue from 'vue'
import UiFormField from '../UiFormField'
export default Vue.extend({
  name: 'UiFormHidden',
  extends: UiFormField
})
</script>
